import React from "react";
import AllRoutes from "routes";

const App = () => {
  return (
    <div>
      <AllRoutes />
    </div>
  );
};

export default App;
